import React, { Component } from 'react';

import { FontAwesomeIcon, WithPopover, Text } from '@schoolinks/ui-components';

import { arrayOf, bool, element, func, shape } from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withState } from 'recompose';
import { bindActionCreators } from 'redux';

import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons/faCircleQuestion';

import MenuItem from '@mui/material/MenuItem';

import { NAV_MENU_ICON_PROPS } from 'components/Common/LayoutV2/constants';

import { SUPPORT_URL } from 'config_app';
import withRouter from 'containers/withRouter';

import withUserType from 'containers/withUserType';
import withMediaInfo from 'HOC/withMediaInfo';
import { isNonEmptyArray } from 'utils/arrays';

import { conditionalObject } from 'utils/objects';

import * as actions from 'modules/WelcomeWidget/actions';

import WelcomeWidgetModal from 'modules/WelcomeWidget/components/WelcomeWidgetModal';

import s from './WelcomeWidget.css';

@withRouter
@withMediaInfo()
@withState('modalOpen', 'setModalOpen', false)
@withUserType
@connect(
  ({ welcomeWidget, user: { featureOnboarding } }) => ({
    ...welcomeWidget,
    featureOnboarding,
  }),
  dispatch => bindActionCreators({ ...actions }, dispatch),
)
@withTranslation()
export default class WelcomeWidget extends Component {
  async componentDidMount() {
    const { fetched, getWelcomeWidget } = this.props;
    if (!fetched) {
      await getWelcomeWidget();
    }
  }

  componentDidUpdate() {
    const {
      content,
      viewed,
      showOnLogin,
      markWelcomeWidgetViewed,
      modalOpen,
      setModalOpen,
    } = this.props;
    if (content && !viewed && !modalOpen && showOnLogin) {
      // user didn't view it, and the message is marked as show on login
      // then show up automatically

      setModalOpen(true);
      markWelcomeWidgetViewed();
    }
  }

  getStartedOnClick = () => {
    const { setModalOpen } = this.props;
    setModalOpen(true);
  };

  renderWelcomeWidgetContents = () => {
    const { user, t } = this.props;
    return (
      <>
        {(user.isCounselor || user.isGuardian || user.isMember) && (
          <MenuItem onClick={this.getStartedOnClick}>
            <Text variant="bodySm400">{t('WelcomeWidget.GettingStarted')}</Text>
          </MenuItem>
        )}
        {(user.isCounselor || user.isStudent || user.isGuardian) && (
          <MenuItem>
            <Text
              component="a"
              href={SUPPORT_URL}
              rel="noopener noreferrer"
              target="_blank"
              variant="bodySm400"
            >
              {t('WelcomeWidget.HelpCenter')}
            </Text>
          </MenuItem>
        )}
        {user.isCounselor && (
          <>
            <MenuItem>
              <Text
                component="a"
                href="https://go.schoolinks.com/summer-trainings"
                rel="noopener noreferrer"
                target="_blank"
                variant="bodySm400"
              >
                {t('WelcomeWidget.WebinarTraining')}
              </Text>
            </MenuItem>
            <MenuItem>
              <Text
                component="a"
                href="https://vip.schoolinks.com/"
                rel="noopener noreferrer"
                target="_blank"
                variant="bodySm400"
              >
                SchooLinks {t('WelcomeWidget.AllAccess')}
              </Text>
            </MenuItem>
          </>
        )}
      </>
    );
  };

  getItems = () => {
    const { user, t } = this.props;
    const { isCounselor, isGuardian, isMember, isStudent } = user;

    return [
      conditionalObject(isCounselor || isGuardian || isMember, {
        textContent: t('WelcomeWidget.GettingStarted'),
        onClick: this.getStartedOnClick,
      }),
      conditionalObject(isCounselor || isStudent || isGuardian, {
        textContent: t('WelcomeWidget.HelpCenter'),
        href: SUPPORT_URL,
      }),
      conditionalObject(isCounselor, {
        textContent: t('WelcomeWidget.WebinarTraining'),
        href: 'https://go.schoolinks.com/summer-trainings',
      }),
      conditionalObject(isCounselor, {
        textContent: t('WelcomeWidget.AllAccess'),
        href: 'https://vip.schoolinks.com/',
      }),
    ];
  };

  render() {
    const { content, modalOpen, setModalOpen, mediaInfo } = this.props;

    const { isDesktop } = mediaInfo;

    return (
      <>
        {isNonEmptyArray(content) && (
          <WelcomeWidgetModal
            open={modalOpen}
            onClose={setModalOpen}
            content={content}
          />
        )}
        {isDesktop ? (
          <WithPopover
            aria-label="Open help menu"
            tooltipProps={{
              placement: 'bottom',
              title: 'Need help?',
            }}
            anchorButtonClass={s.anchorButton}
            hideArrow
            anchorContent={() => (
              <FontAwesomeIcon
                icon={faCircleQuestion}
                {...NAV_MENU_ICON_PROPS}
              />
            )}
            menuProps={{ items: this.getItems() }}
          />
        ) : (
          this.renderWelcomeWidgetContents()
        )}
      </>
    );
  }
}

WelcomeWidget.propTypes = {
  user: shape({}),
  modalOpen: bool,
  setModalOpen: func.isRequired,
  content: arrayOf(element),
  fetched: bool.isRequired,
  getWelcomeWidget: func.isRequired,
  viewed: bool.isRequired,
  showOnLogin: bool.isRequired,
  markWelcomeWidgetViewed: func.isRequired,
  mediaInfo: shape({
    isDesktop: bool.isRequired,
  }).isRequired,
  t: func.isRequired,
};

WelcomeWidget.defaultProps = {
  user: null,
  modalOpen: false,
  content: [],
};
